// Where a message lives, drawn the way the sidebar draws it: # public, lock private, @ a person or a
// group (a "#" beside a person's name would read as a channel called that).
import { Icon, type IconName } from '../../../design/icons';

export function placeIcon(type: string): IconName {
  if (type === 'P') return 'lock';
  if (type === 'D' || type === 'G') return 'at';
  return 'hash';
}

export function PlaceLabel({ name, type }: { name: string; type: string }) {
  return (
    <span className="dest-place">
      <Icon name={placeIcon(type)} size={12} />
      <span className="dest-place-name">{name}</span>
    </span>
  );
}
